import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { ContextService } from 'src/core/services/context.service';

export class DocumentTemplateCategorySummariesDataService extends DataService<typeof Model.General.Logic.ViewModels.DocumentTemplateCategorySummary, Model.General.Logic.ViewModels.DocumentTemplateCategorySummary, IDocumentTemplateCategorySummary> {
    protected map(entity: Model.General.Logic.ViewModels.DocumentTemplateCategorySummary): IDocumentTemplateCategorySummary {
        return new DocumentTemplateCategorySummaryModel(entity);
    }

    public static make(context?: ContextService): DocumentTemplateCategorySummariesDataService {
        return new DocumentTemplateCategorySummariesDataService(context, ctx => ctx.DocumentTemplateCategorySummaries);
    }
}

export class DocumentTemplateCategorySummaryModel extends EntityModel<Model.General.Logic.ViewModels.DocumentTemplateCategorySummary, IDocumentTemplateCategorySummary> implements IDocumentTemplateCategorySummary {
    @property<DocumentTemplateCategorySummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<DocumentTemplateCategorySummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;

    @property<DocumentTemplateCategorySummaryModel>(o => o.entity.type, (o, value) => o.entity.type = value)
    public type: DocumentTemplateCategoryType;

    @property<DocumentTemplateCategorySummaryModel>(o => o.entity.usages, (o, value) => o.entity.usages = value)
    public usages: string;
}



// WEBPACK FOOTER //
// ./src/app/general/document-template-categories/document-template-category.data.ts